<template>
  <div>
    <main-header></main-header>
    <div class="page">
      <div class="w1200">
        <div class="shippint-toptitle">
          <div class="left">
            {{language[languagetype].title}}
          </div>
          <div class="right" @click="backorder">
            {{language[languagetype].back}}
          </div>
        </div>
        <div class="goodspage-box1">
          <span>{{language[languagetype].pnno}}</span>
          <input type="text" :placeholder="language[languagetype].pnnoplea" v-model="pono">
          <div @click="find">{{language[languagetype].search}}</div>
        </div>
        <div class="trackpage-main">
          <div class="box">
            <div class="title">{{language[languagetype].kddh}}</div>
            <div class="cont">{{mbl}}</div>
          </div>
          <div class="box">
            <div class="title">{{kdgs}}</div>
            <div class="cont">
              <a :href="kdlj" target="_blank">{{kdlj}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import MainHeader from './header'
import toast from '../components/taast/toast'
import httppost from '../js/ajax'
let languagetext = require('../js/trackpage.json')
export default {
  name: 'about',
  data () {
    return {
      language: {},
      languagetype: 'cn',
      pono: '',
      mbl: '',
      kdgs: '',
      kdlj: ''
    }
  },
  methods: {

    formatDayTime: function (val) {
      if (val) {
        let date = new Date(val)
        let Y = date.getFullYear()
        let M = date.getMonth() + 1
        let D = date.getDate()

        if (M < 10) {
          M = '0' + M
        }
        if (D < 10) {
          D = '0' + D
        }
        return Y + '.' + M + '.' + D
      } else {
        return ''
      }
    },
    backorder: function () {
      this.$router.push({name: 'order'})
    },
    find: function () {
      const that = this
      if (that.pono == null || that.pono === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].pnnonull)
        return false
      }
      httppost.post('Api/http', {
        name: 'portal.sea.orderDetail.query',
        customerName: that.username.customerName,
        allNo: that.pono
      }).then((res) => {
        if (res.code === '0') {
          if (res.data.length === 0) {
            that.$refs.toasttext.show(that.language[that.languagetype].nodata)
            return false
          }
          that.mbl = res.data.fmsExternalOrderDetailList[0].mblNo
          that.kdgs = res.data.fmsExternalOrderDetailList[0].carriercode
          if (that.kdgs === 'UPS' || that.kdgs === 'ups') {
            that.kdlj = 'https://www.ups.com/ca/en/services/tracking.page'
          } else if (that.kdgs === 'DHL' || that.kdgs === 'dhl') {
            that.kdlj = 'https://www.dhl.com/cn-zh/home.html'
          } else if (that.kdgs === 'TNT' || that.kdgs === 'tnt') {
            that.kdlj = 'https://www.tnt.com/express/zh_cn/site/home.html#'
          } else if (that.kdgs === '联邦' || that.kdgs === 'FedEX') {
            that.kdlj = 'https://www.fedex.com/en-us/home.html'
          } else if (that.kdgs === 'SFSY') {
            that.kdlj = 'https://www.sf-express.com/cn/sc/'
          } else if (that.kdgs === 'DB') {
            that.kdlj = 'https://www.deppon.com/track/ordertrack'
          }
        } else {
          that.$refs.toasttext.show(res.msg)
        }
      }).catch(err => {
        that.$refs.toasttext.show(err.msg)
      })
    }
  },
  components: {
    MainHeader,
    toast
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    that.username = JSON.parse(localStorage.getItem('username'))
    if (that.username == null) {
      setTimeout(function () {
        that.$refs.toasttext.show(that.language[that.languagetype].islogin)
      }, 300)
      setTimeout(function () {
        that.$router.push({name: 'login'})
      }, 1000)
    }
  },
  beforeCreate () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{min-height: 400px;background-color: #f6f6f6;padding-bottom: 20px;}
  .shippint-toptitle{height: 92px;padding-top: 9px;display: flex;justify-content: space-between;}
  .shippint-toptitle .left{line-height: 92px;color: #333;font-size: 30px;}
  .shippint-toptitle .right{color: #999;font-size: 16px;line-height: 92px;cursor: pointer;background:url("../assets/backbtn.png") 0 center no-repeat;padding-left: 27px;}
  .goodspage-box1{width: 100%;height:90px;display: flex;box-sizing: border-box;padding: 0 30px 0 30px;align-items: center;background-color: #ffff;}
  .goodspage-box1 span{font-size: 18px;margin-right: 5px;}
  .goodspage-box1 input{width: 278px;height: 30px;border: 1px solid #c5c5c5;text-indent: 9px;color: #333;margin-right: 5px}
  .goodspage-box1 input::placeholder{color: #999;}
  .goodspage-box1 div{width: 110px;height: 32px;margin-left:26px;background-color: #2562ef;color: #fff;font-size: 16px;text-align: center;line-height: 32px;border-radius: 3px;cursor: pointer;}
  .trackpage-main{width: 100%;height: 370px;box-sizing: border-box;padding:0 30px;background-color: #fff;margin-top: 20px;padding-top: 21px;}
  .trackpage-main .box{width: 100%;height: auto;margin-bottom: 17px;}
  .trackpage-main .box .title{width: 100%;height: 33px;line-height: 33px;font-size: 20px;font-weight: bold;}
  .trackpage-main .cont{color: #333;line-height: 26px;}
  </style>



// WEBPACK FOOTER //
// src/page/express.vue